export default function _identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_identity.js
// module id = 167
// module chunks = 1